import { render, staticRenderFns } from "./resource-download.vue?vue&type=template&id=f0722344&scoped=true"
import script from "./resource-download.vue?vue&type=script&lang=js"
export * from "./resource-download.vue?vue&type=script&lang=js"
import style0 from "./resource-download.vue?vue&type=style&index=0&id=f0722344&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0722344",
  null
  
)

export default component.exports